import { cn } from "@omni/utils/styles";

import { Star } from "./star/star.component";

export type RatingProps = {
    max?: number;
    value: number;
    size?: number;
    className?: string;
};

const Rating = ({ className, max = 5, value, size = 32 }: RatingProps) => {
    const starValues = Array.from({ length: max }, (_, index) =>
        Math.min(Math.max(value - index, 0), 1)
    );

    return (
        <div className={cn("tw:flex tw:pb-px", className)}>
            <span
                className={cn(
                    "tw:inline-flex tw:justify-center tw:items-center tw:gap-1"
                )}
            >
                {starValues.map((starValue, index) => {
                    return (
                        <Star
                            value={starValue}
                            key={index}
                            size={size}
                        />
                    );
                })}
            </span>
        </div>
    );
};

export { Rating };
